import { useSelector } from 'react-redux'
import { StateExtended } from '../../_config/interfaces/stateExtended'


export function useAppLoaderSelector() {
  const show = useSelector((state: StateExtended) => state.loader.fpLoader)
  return show
}
export function useMenuCollapseSelector() {
  const show = useSelector((state: StateExtended) => state.loader.menuCollapse)
  return show
}